export const APPLICATION_PROFILE_RECEIVED = "APPLICATION_PROFILE_RECEIVED";
